import Drupal from 'drupal';
import jQuery from 'jquery';
import once from 'once';

(function initContact($, Drupal) {

    class Contact{
        $container: JQuery;
        $info: JQuery;
        $links: JQuery;
        $address: JQuery;
        static contact = [] as Contact[];

        constructor(container: Element) {
            /**
             * @type {jQuery}
             */
            this.$container = $(container);
            /**
             * @type {jQuery}
             */
            this.$info = this.$container.find('.c-contact-item__info');
            /**
             * @type {jQuery}
             */
            this.$links = this.$container.find('.c-contact-item__links');
            /**
             * @type {jQuery}
             */
            this.$address = this.$container.find('.c-contact-item__address');

            // Remove styles if element does not exist
            if (!this.$links.length || !this.$info.length || !this.$info.find('p:nth-child(2)').length) {
                this.$address.css('max-height', 'none');
            }
        }
    }

    // Expose constructor in the public space.
    Drupal.Contact = Contact;

    // Attach the behavior to the contact group element.
    Drupal.behaviors.contact = {
        attach: function (context, settings) {
            const contact = once('contact-item', '.c-contact-item');
            if(contact.length) {
                const c = contact.length;
                for (let i = 0; i < c; i++) {
                    Contact.contact.push(new Contact(contact[i]));
                }
            }
        },
    };
})(jQuery, Drupal);
